// extracted by mini-css-extract-plugin
export default {"container":"m_xO5M"};